import { render, staticRenderFns } from "./estadisticas-viajante.vue?vue&type=template&id=830a0e1e&scoped=true&"
import script from "./estadisticas-viajante.vue?vue&type=script&lang=ts&"
export * from "./estadisticas-viajante.vue?vue&type=script&lang=ts&"
import style0 from "./estadisticas-viajante.vue?vue&type=style&index=0&id=830a0e1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830a0e1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VChip,VCol,VIcon,VRow,VSpacer,VTab,VTabItem,VTabs,VTabsItems})
